import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError, AxiosResponse } from 'axios';
import { Slices } from 'ducks/slices';
import { ScheduledBatchesListAPI } from 'ducks/types/api-types';
import { Query } from 'ducks/types/query-types';
import { Andromeda } from 'utils/axios';
import { handleError } from 'utils/errors';
import { replaceSearchQuery } from 'utils/queries';

export const getScheduledBatchHistory = createAsyncThunk<ScheduledBatchesListAPI[], number>(
  `${Slices.SCHEDULED_BATCH_HISTORY}/getHistory`,
  async (entity_id, { rejectWithValue }) => {
    try {
      const post_data: Query = {
        max_rows: 100,
      };
      const res: AxiosResponse['data'] = await Andromeda.get(
        `/scheduled_batches/${entity_id}/batches/list${replaceSearchQuery(post_data)}`,
      );
      return res.data;
    } catch (error) {
      handleError(error);
      return rejectWithValue(error as AxiosError);
    }
  },
);
